import { Component } from '@angular/core';
import { ProfileComponent } from '../profile/profile.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [ProfileComponent, NgIf],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  profileVisible = false;

  displayProfile() {
    this.profileVisible = !this.profileVisible;
  }

}
